import {
    Input,
    Component,
    Output,
    EventEmitter,
    Inject
} from '@angular/core';

import { TOAST_DATA } from '../toastr.service';

@Component({
    selector: 'app-toast-success-pixel',
    templateUrl: './toast-success-pixel.component.pug',
    styleUrls: ['./toast-success-pixel.component.less'],
})
export class ToastSuccessPixelComponent {
    constructor(
        @Inject(TOAST_DATA) public data: any
    ) {
    }
}
